const SLATE_ID_STORAGE_KEY = "sc:devtools:sc-slate-id";

export const getSlateId = (): string | null =>
  sessionStorage.getItem(SLATE_ID_STORAGE_KEY);

export const setSlateId = (value: string): void =>
  sessionStorage.setItem(SLATE_ID_STORAGE_KEY, value);

export const clearSlateId = (): void =>
  sessionStorage.removeItem(SLATE_ID_STORAGE_KEY);
